export const T = {
  en_GB: {
    verifyContinue: "Verify & Continue",
    codeExpires: "Code expires in 10 minutes",
    didntReceive: "Didn't receive it?",
    resendIn: (seconds: string) => `Resend in ${seconds}s`,
    resendCode: "Resend code",
    verificationCode: "Verification Code",
    enterCodeFrom: "Enter the 6-digit code from your",
    email: "email",
    sms: "SMS",
  },
  nb_NO: {
    verifyContinue: "Verifiser og fortsett",
    codeExpires: "Koden utløper om 10 minutter",
    didntReceive: "Mottok du den ikke?",
    resendIn: (seconds: string) => `Send på nytt om ${seconds}s`,
    resendCode: "Send kode på nytt",
    verificationCode: "Verifiseringskode",
    enterCodeFrom: "Skriv inn den 6-sifrede koden fra din",
    email: "e-post",
    sms: "SMS",
  },
} as const;
